import React from 'react';
import { NavigationButtonWrapper, PageNumberWrapper } from './styled';
import {
  Container,
  TextAppearance,
  LinkButton,
  ContainerGutter,
  TextColor,
  Text,
  DisableFocusWrapper,
  ArrowLeft,
  ArrowRight,
  TextCustom,
  TextSize,
  TextLineHeight,
  TextWeight,
} from '@vw-marketing/us-components';

interface PageBarProps {
  setPage: (currentPage: number) => void;
  pageNumber: number;
  totalPages: number;
}
const PageBar: React.FC<PageBarProps> = (props): JSX.Element => {
  const { setPage, pageNumber, totalPages } = props;

  return (
    <Container horizontalAlign={'space-between'} verticalAlign={'center'}>
      <NavigationButtonWrapper>
        <Text appearance={TextAppearance.label100}>
          <DisableFocusWrapper>
            <LinkButton
              onClick={() => setPage(pageNumber - 1)}
              disabled={pageNumber <= 1}
            >
              <Container
                verticalAlign={'center'}
                gutter={ContainerGutter.static150}
              >
                <ArrowLeft />
                <Text
                  appearance={TextAppearance.label100}
                  color={TextColor.inherit}
                >
                  Previous
                </Text>
              </Container>
            </LinkButton>
          </DisableFocusWrapper>
        </Text>
      </NavigationButtonWrapper>
      <PageNumberWrapper>
        {' '}
        <TextCustom
          appearance={TextAppearance.headline200}
          style={{
            fontSize: TextSize.TextSize16,
            lineHeight: TextLineHeight.TextLineHeight20,
          }}
        >
          <TextCustom style={{ fontWeight: TextWeight.bold }}>
            {pageNumber}
          </TextCustom>
          {` of ${totalPages}`}
        </TextCustom>{' '}
      </PageNumberWrapper>
      <NavigationButtonWrapper>
        <Text appearance={TextAppearance.label100}>
          <DisableFocusWrapper>
            <LinkButton
              onClick={() => setPage(pageNumber + 1)}
              disabled={pageNumber >= totalPages}
            >
              <Container
                verticalAlign={'center'}
                gutter={ContainerGutter.static150}
              >
                <Text
                  appearance={TextAppearance.label100}
                  color={TextColor.inherit}
                >
                  Next
                </Text>
                <ArrowRight />
              </Container>
            </LinkButton>
          </DisableFocusWrapper>
        </Text>
      </NavigationButtonWrapper>
    </Container>
  );
};

export default PageBar;
